module.exports = __webpack_public_path__ + "img/jacobWei.8217357e.jpeg";